import { STRIPE_PREPROD_KEY, STRIPE_PROD_KEY } from "../../../common/Constants";
import { ENV } from "../../../utils/EmpUtil";

const STRIPE_PUBLISHABLE_KEYS = {
  prod: STRIPE_PROD_KEY,
  preprod: STRIPE_PREPROD_KEY,
};

const getStripePublishableKey = () => {
  // Map environments to stripe key types
  const isProduction = ENV === "prod";
  const keyType = isProduction ? "prod" : "preprod";

  return STRIPE_PUBLISHABLE_KEYS[keyType];
};

export const STRIPE_CONFIG = {
  publishableKey: getStripePublishableKey(),
  appearance: {
    variables: {
      fontFamily: "Arial, sans-serif",
      buttonBorderRadius: "24px",
      colorPrimary: "#0562D2",
      colorBackground: "#ffffff",
      colorText: "#000000",
      fontSizeBase: "16px",
      spacingUnit: "12px",
    },
  },
};
